module.exports = __webpack_public_path__ + "static/img/7.4608f86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/7.png
// module id = n25X
// module chunks = 0